import { useLayoutEffect, useState } from 'react';
import { useThemeUI } from 'theme-ui';

const getPredefinedBreakpoints = (breakpoints, theme) => {
  let query = breakpoints;

  switch (breakpoints) {
    case 'mobile':
      query = `(max-width: ${theme.breakpoints?.[0]})`;
      break;
    case 'tablet':
      query = `(min-width: ${theme.breakpoints?.[0]}) and (max-width: ${theme.breakpoints?.[1]})`;
      break;
    case 'desktop':
      query = `(min-width: ${theme.breakpoints?.[1]})`;
      break;
    default:
      break;
  }
  return query;
};

const useMatchMedia = (media) => {
  const { theme } = useThemeUI();
  const mediaOrPredefinedValue = getPredefinedBreakpoints(media, theme);
  const [matches, setMatches] = useState();

  const mediaListener = ({ matches }) => {
    setMatches(matches);
  };

  useLayoutEffect(() => {
    const mq = window.matchMedia(mediaOrPredefinedValue);

    setMatches(mq.matches);

    mq.addEventListener ? mq.addEventListener('change', mediaListener) : mq.addListener(mediaListener);

    return () => {
      mq.removeEventListener ? mq.removeEventListener('change', mediaListener) : mq.removeListener(mediaListener);
    };
  }, [mediaOrPredefinedValue]);

  return matches;
};

export default useMatchMedia;
